import { logger } from '@/shared/utils';
import { getUsersProfile } from '@/infrastructure/sdk';
import { store } from '@/app/store';
import { setUserInfoMap } from '../model';
import { updateUserDeleted } from '@/features/users/model';
import { i18n } from '@/localization/i18n';

export * from './userHelpers';
export * from './userBlockAction';
export * from './userPhotoViewer';

const inFlightUsers = new Set();

export const fetchUsersInfo = async userIds => {
   const dispatch = store.dispatch;
   if (!userIds || userIds.length === 0) {
      return;
   }

   const uniqueUserIds = [...new Set(userIds)].filter(id => !inFlightUsers.has(id));

   if (uniqueUserIds.length === 0) {
      return;
   }

   uniqueUserIds.forEach(id => inFlightUsers.add(id));

   const CHUNK_SIZE = 50;
   const chunks = [];

   for (let i = 0; i < uniqueUserIds.length; i += CHUNK_SIZE) {
      chunks.push(uniqueUserIds.slice(i, i + CHUNK_SIZE));
   }

   try {
      const results = [];
      const foundUserIds = new Set();

      for (const chunk of chunks) {
         const res = await getUsersProfile(chunk);
         results.push(res);

         if (typeof window !== 'undefined') {
            await new Promise(resolve => setTimeout(resolve, 0));
         }
      }

      const allUsers = [];

      results.forEach(res => {
         if (res?.users) {
            const usersWithChatType = res.users.map(user => {
               foundUserIds.add(user.userId);
               return { ...user, chatType: 'chat' };
            });

            allUsers.push(...usersWithChatType);
         }
      });

      const missingUserIds = uniqueUserIds.filter(id => !foundUserIds.has(id));

      const state = store.getState();
      const existingUsers = state.userInfoData?.users || {};

      missingUserIds.forEach(id => {
         // Only mark deleted if user was already known earlier
         if (existingUsers[id]) {
            dispatch(
               updateUserDeleted({
                  userId: id,
                  isDeleted: true,
                  deletedUserName: i18n.t('chat.DELETED_USER'),
               }),
            );
         }
         // else: new user → do nothing
      });

      if (allUsers.length > 0) {
         dispatch(setUserInfoMap(allUsers));
      }
   } catch (error) {
      logger.error('Error fetching user profiles:', error);
   } finally {
      uniqueUserIds.forEach(id => inFlightUsers.delete(id));
   }
};
